import { render } from "./pageLoader.vue?vue&type=template&id=7f4fc434&scoped=true"
import script from "./pageLoader.vue?vue&type=script&lang=js"
export * from "./pageLoader.vue?vue&type=script&lang=js"

import "./pageLoader.vue?vue&type=style&index=0&id=7f4fc434&scoped=true&lang=css"

import exportComponent from "F:\\قبل النهائي\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4fc434"]])

export default __exports__